import {
    UsersIcon,
    ClockIcon,
    CheckCircleIcon,
    AlertCircleIcon,
} from 'lucide-react'
import useUserJobStats from '../hooks/useUserJobStats'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export const JobsStats = () => {

    const { total, active, closed, isLoading } = useUserJobStats();

    if (isLoading || total === undefined) {
        return (
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {Array.from({ length: 3 }).map((_, idx) => (
                    <div key={idx} className="bg-white dark:bg-gray-800 overflow-hidden shadow rounded-lg px-4 py-5 sm:p-6">
                        <div className="flex items-center"><Skeleton circle width={48} height={48} className="mr-4" /><div className="flex-1"><Skeleton height={16} width="40%" className="mb-2" /><Skeleton height={30} width="20%" /></div></div>
                    </div>
                ))}
            </div>
        )
    }

    return (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            <div className="bg-white dark:bg-gray-800 overflow-hidden shadow rounded-lg">
                <div className="px-4 py-5 sm:p-6">
                    <div className="flex items-center">
                        <div className="flex-shrink-0 bg-blue-100 dark:bg-blue-900/40 rounded-md p-3">
                            <UsersIcon className="h-6 w-6 text-blue-600" />
                        </div>
                        <div className="ml-5 w-0 flex-1">
                            <dl>
                                <dt className="text-sm font-medium text-gray-500 dark:text-gray-400 truncate">
                                    Total Jobs
                                </dt>
                                <dd className="text-3xl font-semibold text-gray-900 dark:text-gray-100">{total}</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-white dark:bg-gray-800 overflow-hidden shadow rounded-lg">
                <div className="px-4 py-5 sm:p-6">
                    <div className="flex items-center">
                        <div className="flex-shrink-0 bg-green-100 dark:bg-green-900/40 rounded-md p-3">
                            <CheckCircleIcon className="h-6 w-6 text-green-600" />
                        </div>
                        <div className="ml-5 w-0 flex-1">
                            <dl>
                                <dt className="text-sm font-medium text-gray-500 dark:text-gray-400 truncate">
                                    Active Jobs
                                </dt>
                                <dd className="text-3xl font-semibold text-gray-900 dark:text-gray-100">{active}</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white dark:bg-gray-800 overflow-hidden shadow rounded-lg">
                <div className="px-4 py-5 sm:p-6">
                    <div className="flex items-center">
                        <div className="flex-shrink-0 bg-red-100 dark:bg-red-900/40 rounded-md p-3">
                            <AlertCircleIcon className="h-6 w-6 text-red-600" />
                        </div>
                        <div className="ml-5 w-0 flex-1">
                            <dl>
                                <dt className="text-sm font-medium text-gray-500 dark:text-gray-400 truncate">
                                    Closed
                                </dt>
                                <dd className="text-3xl font-semibold text-gray-900 dark:text-gray-100">{closed}</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
